import Swiper from 'swiper/bundle';

const AUTOPLAY_DEFAULT = 4000;

function setBulletDuration(container, ms) {
    container.style.setProperty('--testimonial-bullet-duration', `${ms / 1000}s`);
}

function restartBulletAnimation(container) {
    const bullet = container.querySelector('.swiper-pagination-bullet-active');
    if (!bullet) return;
    bullet.classList.remove('is-animating');
    void bullet.offsetWidth; // reflow erzwingen, damit die Animation neu startet
    bullet.classList.add('is-animating');
}

function updateCount(swiper, container) {
    const countEl = container.querySelector('.swiper-count');
    if (!countEl) return;
    const total = swiper.slides.filter(s => !s.classList.contains('swiper-slide-duplicate')).length;
    countEl.textContent = `${swiper.realIndex + 1} / ${total}`;
}

function handleSlide(swiper, container) {
    updateCount(swiper, container);
    container.querySelectorAll('video').forEach(v => {
        v.pause();
        v.onended = null;
        v.onloadedmetadata = null;
    });

    const activeSlide = swiper.slides[swiper.activeIndex];
    const video = activeSlide?.querySelector('video');

    if (video) {
        swiper.autoplay.stop();
        video.currentTime = 0;

        const startVideo = () => {
            setBulletDuration(container, video.duration * 1000);
            restartBulletAnimation(container);
            video.play();
            video.onended = () => swiper.slideNext();
        };

        if (video.readyState >= 1) {
            startVideo();
        } else {
            video.onloadedmetadata = startVideo;
        }
    } else {
        setBulletDuration(container, AUTOPLAY_DEFAULT);
        restartBulletAnimation(container);
        swiper.autoplay.start();
    }
}

export function initSwiperArticles (query = document.querySelectorAll('.collectionArticles__preview.swiper')) {
    for (const container of query) {
        new Swiper(container, {
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoHeight: false,
            autoplay: {
                delay: AUTOPLAY_DEFAULT,
                disableOnInteraction: false,
            },
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            on: {
                afterInit (swiper) {
                    handleSlide(swiper, container);
                },
                slideChangeTransitionEnd (swiper) {
                    handleSlide(swiper, container);
                },
            }
        });
    }
}